module.exports = __webpack_public_path__ + "static/media/数字化进销存.1fd81fb4.png";